//如果要预渲染那么不能进行懒加载
import Home from '@/components/home/Home.vue';
import Collect from '@/components/collect/Collect.vue';
import Login from '@/components/login/Login.vue';
import Paypalurl from '@/components/common/paypal.vue';
import Pay from '@/components/pay/Pay.vue';
import Jianjie from '@/components/about/Jianjie.vue';
import About from '@/components/about/About.vue';
import Lianxi from '@/components/about/Lianxi.vue';
import Shouhou from '@/components/about/Shouhou.vue';
import Tiaokuan from '@/components/about/Tiaokuan.vue';
import Xieyi from '@/components/about/Xieyi.vue';
import Yinsi from '@/components/about/Yinsi.vue';
import HomeCenter from '@/components/home/Center.vue';
import MessageCenter from '@/components/message/Center.vue';
import OrderCenter from '@/components/order/Center.vue';
import DaizhifuCenter from '@/components/order/Daizhifu.vue';
import Order from '@/components/order/Order.vue';
import InvoiceCenter from '@/components/invoice/center.vue';
import InfoCenter from '@/components/info/Center.vue';
import Cashback from '@/components/cashback/Cashback.vue';
import Cashbacklog from '@/components/cashback/Log.vue';
import Cashbackuse from '@/components/cashback/Use.vue';
import Couponcenter from '@/components/coupon/Center.vue';

export const routes = [
  {
    path: '/home',
    children: [
      // 资产仓库
      {
        path: '/home/index',
        name: 'homeabout',
        components: {
          default: HomeCenter
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true
        }
      },
      {
        path: '/home/message',
        name:'homemessage',
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: false
        },
        component: MessageCenter
      },
      {
        path: '/home/coupon',
        name:'homecoupon',
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: false
        },
        component: Couponcenter
      },
      {
        path: '/home/order',
        children: [
          // 资产仓库
          {
            path: '/',
            name: 'order',
            components: {
              default: OrderCenter
            },
            meta: {
              // 需要登录控制
              NProgress: true,
              // 需要登录控制
              requireAuth: true
            }
          },
          {
            path: '/home/order/daizhifu',
            name: 'daizhifu',
            components: {
              default: DaizhifuCenter
            },
            meta: {
              // 需要登录控制
              NProgress: true,
              // 需要登录控制
              requireAuth: true
            }
          }
        ],
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true
        },
        component: Order
      },




      {
        path: '/home/cashback',
        children: [
          // 资产仓库
          {
            path: '/',
            name: 'homecashbacklog',
            components: {
              default: Cashbacklog
            },
            meta: {
              // 需要登录控制
              NProgress: true,
              // 需要登录控制
              requireAuth: true
            }
          },
          {
            path: '/home/cashback/use',
            name: 'homecashbackuse',
            components: {
              default: Cashbackuse
            },
            meta: {
              // 需要登录控制
              NProgress: true,
              // 需要登录控制
              requireAuth: true
            }
          }
        ],
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true
        },
        component: Cashback
      },



      {
        path: '/home/invoice',
        name:'homeinvoice',
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true
        },
        component: InvoiceCenter
      },
      {
        path: '/home/info',
        name:'homeinfo',
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true
        },
        component: InfoCenter
      }
    ],
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: true
    },
    component: Home
  },
  {
    path: '/collect/:tokenbus?/:type?',
    name:'collect',
    props:(route)=>{
      return {
        tokenbus:route.params.tokenbus,
        type:route.params.type
      }
    },
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: false
    },
    component: Collect
  },
  {
    path: '/about',
    children: [
      // 资产仓库
      {
        path: '/',
        name: 'about',
        components: {
          default: Jianjie
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true
        }
      },
      {
        path: '/about/lianxi',
        name: 'aboutlianxi',
        components: {
          default: Lianxi
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true
        }
      },
      // 资产仓库
      {
        path: '/about/shouhou',
        name: 'aboutshouhou',
        components: {
          default: Shouhou
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true
        }
      },
      // 资产仓库
      {
        path: '/about/tiaokuan',
        name: 'abouttiaokuan',
        components: {
          default: Tiaokuan
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true
        }
      },
      // 资产仓库
      {
        path: '/about/xieyi',
        name: 'aboutxieyi',
        components: {
          default: Xieyi
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true
        }
      },
      // 资产仓库
      {
        path: '/about/yinsi',
        name: 'aboutyinsi',
        components: {
          default: Yinsi
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true
        }
      }
    ],
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: false
    },
    component: About
  },
  {
    path: '/login',
    name:'login',
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: false
    },
    component: Login
  },
  {
    path: '/paypal/:no',
    name: 'paypalid',
    props:(route)=>{
      return {
        no:route.params.no
      }
    },
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth:true
    },
    component: Paypalurl
  },
  {
    path: '/:token/pay',
    name:'pay',
    props:(route)=>{
      return {
        token:route.params.token
      }
    },
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: false
    },
    component: Pay
  },
  {
    path:'*',
    redirect:'/home/index'
  }
];



// WEBPACK FOOTER //
// ./src/router/routes.js